const commonObj = {};

export default commonObj;